var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchool1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119 657L119 685",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.5,
    cy: 652.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.829 649.888L120.354 646.027C120.278 645.991 120.202 645.991 120.126 646.027L109.651 649.888C109.651 649.888 109.651 649.888 109.632 649.888C109.613 649.888 109.613 649.906 109.594 649.906C109.594 649.906 109.575 649.906 109.575 649.923C109.556 649.923 109.556 649.941 109.537 649.941C109.537 649.941 109.537 649.941 109.518 649.959C109.499 649.976 109.499 649.976 109.48 649.994C109.48 650.012 109.461 650.012 109.461 650.03V650.047C109.461 650.065 109.461 650.065 109.442 650.083V650.1C109.442 650.118 109.442 650.136 109.442 650.154V654.741C108.626 654.883 108 655.556 108 656.353C108 657.256 108.797 658 109.765 658C110.733 658 111.53 657.256 111.53 656.353C111.53 655.538 110.903 654.883 110.087 654.741V650.579L112.118 651.323V654.387C112.118 655.272 112.991 656.087 114.604 656.689C116.122 657.238 118.115 657.557 120.24 657.557C122.366 657.557 124.377 657.256 125.876 656.689C127.47 656.105 128.362 655.29 128.362 654.387V651.323L130.81 650.419C130.924 650.384 131 650.277 131 650.154C131 650.03 130.943 649.941 130.829 649.888ZM110.922 656.353C110.922 656.937 110.41 657.415 109.784 657.415C109.158 657.415 108.645 656.937 108.645 656.353C108.645 655.768 109.158 655.29 109.784 655.29C110.41 655.29 110.922 655.768 110.922 656.353ZM127.755 654.404C127.755 655.662 124.738 656.99 120.24 656.99C115.743 656.99 112.725 655.644 112.725 654.404V651.553L120.126 654.28C120.164 654.298 120.202 654.298 120.24 654.298C120.278 654.298 120.316 654.298 120.354 654.28L127.755 651.553V654.404ZM127.945 650.88L120.24 653.714L112.535 650.862L110.6 650.154L120.24 646.593L129.88 650.154L127.945 650.88Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool1);
export default __webpack_public_path__ + "static/media/school_1.d1af2956c962abe29bf68a36d06e5c77.svg";
export { ForwardRef as ReactComponent };